import { GetCurrencySymbol } from '../../utils/Currency';
import { GetFloatNumber } from '../../utils/NumberFormatter';
import { SupportServiceIcon } from '../../utils/SVGIcon';

function Tr({ item }) {
    return (
        <tr className={`opacity-70 h-[96px] ${item?.demo ? 'placeholder-mode' : ''}`}>
            <td className="py-4 text-black font-medium">
                <div className="flex justify-start items-start gap-2 mb-1">
                    <span className="inline-block w-10 h-10 min-w-max border border-primary-100 rounded-full overflow-hidden mt-1">
                        {item?.logoUrl ? (
                            <img src={item?.logoUrl} alt="" className="w-full h-full" />
                        ) : (
                            <span className="inline-block size-full">
                                <SupportServiceIcon />
                            </span>
                        )}
                    </span>
                    <div>
                        <b>
                            <span>{item?.productTitle || '--'}</span>
                        </b>
                        <br />
                        <h3>
                            <span className="text-base text-secondary">
                                {item?.packageName || '--'}
                            </span>
                        </h3>
                        <p className="text-sm font-normal opacity-70">
                            <span>{item?.property || ``}</span>
                        </p>
                        {item?.domain && (
                            <span className="text-sm font-normal"> &nbsp;#{item?.domain}</span>
                        )}
                    </div>
                </div>

                {/* {item?.limitBy === 'ppu' && (
                    <div className="ml-[48px] text-sm">
                        <span>
                            PPU: <span>{item?.limitByValue || 0}</span>
                        </span>
                    </div>
                )} */}
            </td>
            <td className="py-4 text-black  text-sm font-medium text-center">
                <span>{item?.quantityString}</span>
                {/* <span>{`${item?.quantity} ${
                    item?.unitName === 'ppu' ? 'Package' : item?.unitName
                }`}</span> */}
            </td>
            <td className="py-4 text-black  text-sm font-medium text-center">
                <span>{item?.currency}</span>
            </td>
            <td className="py-4 text-black text-sm  font-medium text-right">
                <span>{`${GetFloatNumber(item?.priceOffer)}`}</span>
            </td>
        </tr>
    );
}

function InvoiceDataTable({ info }) {
    const items = info?.invoiceItems;
    const { amountBilled, amountPaid, amountDue, currency } = info.invoice || {};

    return (
        <table className=" w-full mb-5 table-fixed">
            <thead>
                <tr className="opacity-70">
                    <th className="text-black opacity-75 font-extrabold text-left">
                        Product/Service
                    </th>
                    <th className="text-black opacity-75 font-extrabold w-[15%] text-center">
                        Quantity
                    </th>
                    <th className="text-black opacity-75 font-extrabold w-[15%] text-center">
                        Currency
                    </th>
                    <th className="text-black opacity-75 font-extrabold w-[20%] text-right">
                        Total
                    </th>
                </tr>
            </thead>
            <tbody>
                {items?.map((item) => (
                    <Tr key={item.id} item={item} />
                ))}
                <tr className="border-t-0 print:border-t [&>td]:hidden print:[&>td]:table-cell">
                    <td />
                    <td />
                    <td className="py-2 text-primary-700 font-medium text-center border-b">
                        Billed Amount
                    </td>
                    <td className="py-2 text-black font-medium text-right border-b">{`${GetCurrencySymbol(currency)}${GetFloatNumber(amountBilled)}`}</td>
                </tr>
                <tr className="[&>td]:hidden print:[&>td]:table-cell">
                    <td />
                    <td />
                    <td className="py-2 text-primary-700 font-medium text-center border-b">
                        Paid Amount
                    </td>
                    <td className="py-2 text-black font-medium text-right border-b">{`${GetCurrencySymbol(currency)}${GetFloatNumber(amountPaid)}`}</td>
                </tr>
                <tr className="[&>td]:hidden print:[&>td]:table-cell">
                    <td />
                    <td />
                    <td className="py-2 text-primary-700 font-medium text-center">Due Amount</td>
                    <td className="py-2 text-black font-medium text-right">{`${GetCurrencySymbol(currency)}${GetFloatNumber(amountDue)}`}</td>
                </tr>
            </tbody>

            {/* <tfoot className="hidden print:table-footer-group break-inside-avoid">
                <tr>
                    <td style={{ width: '800px', height: '200px' }} aria-label="Loading..." />
                </tr>
            </tfoot> */}
        </table>
    );
}

export default InvoiceDataTable;
